var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_dashboard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "base",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dashboard",
    d: "M44,198.5a.5.5,0,0,1-.5.5h-4a.5.5,0,0,1-.5-.5v-4a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5Zm-.5-8.5a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5Zm-9,0a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5Zm0,9a.5.5,0,0,0,.5-.5v-4a.5.5,0,0,0-.5-.5h-4a.5.5,0,0,0-.5.5v4a.5.5,0,0,0,.5.5Z",
    transform: "translate(-25 -180)",
    fill: "#222a41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.bbd6a2d6.svg";
export { ForwardRef as ReactComponent };